const Locations = [
    { "value": "Room G01", "description": "Principal" },
    { "value": "Room G02", "description": "Staff Room" },
    { "value": "Room G03", "description": "Room G03" },
    { "value": "Room G04", "description": "PE Lab / Network Lab" },
    { "value": "Room G05", "description": "Physics Lab / Exam Control room" },
    { "value": "WaterFilter", "description": "Water Filter" },
    { "value": "Room G06", "description": "CAD Lab" },
    { "value": "Girls Washroom", "description": "Girls WashRoom" },
    { "value": "Room G07", "description": "Room G07" },
    { "value": "Room G08", "description": "EMEC Lab / Basic EE Lab" },
    { "value": "Room G09", "description": "Room G09" },
    { "value": "Room G10", "description": "HOD EX/EE / Simultaneous Lab" },
    { "value": "Room G11", "description": "Room G11" },
    { "value": "Room G12", "description": "Room G12" },
    { "value": "Room G13", "description": "Power System Lab" },
    { "value": "HOD ME", "description": "HOD ME" },
    { "value": "Room G15", "description": "Room G15" },
    { "value": "Room G18", "description": "Workshop" },
    { "value": "Boys Washroom", "description": "Boys WashRoom" },
    { "value": "Room G19", "description": "Staff Room" },
    { "value": "Room G20", "description": "BME Lab" },
    { "value": "Room G21", "description": "RAC Lab" },
    { "value": "Room G22", "description": "HMT Lab" },
    { "value": "Room G23", "description": "Chemistry Lab" },
    { "value": "Room G24", "description": "Mechanics Lab" },
    { "value": "To SRIST", "description": "Second College" },
    { "value": "Auditorium", "description": "Auditorium" },
    { "value": "Fountain", "description": "Fountain" },
    { "value": "HOD CE", "description": "Civil Department" },
    { "value": "Room G25", "description": "Room G25" },
    { "value": "Room G26", "description": "Room G26" },
    { "value": "Room G27", "description": "PPT Hall" },
    { "value": "Room G28", "description": "Room G28" },
    { "value": "Room G29", "description": "IT Lab 3" },
    { "value": "HOD IT", "description": "HOD IT" },
    { "value": "Room G30", "description": "IT Lab 1" },
    { "value": "Room G31", "description": "IT Lab 2" },
    { "value": "Room G32", "description": "Room G32" },
    { "value": "Room G33", "description": "Room G33" },
    { "value": "Room G34", "description": "Account Office" },
    { "value": "Room G35", "description": "Room G35" },
    { "value": "Room G36", "description": "Room G36" },
    { "value": "Room G37", "description": "Communication Skill Lab" },
    { "value": "Room G38", "description": "Room G38" },
    { "value": "Room G39", "description": "Room G39" },
    { "value": "Room G40", "description": "Room G40" },
    { "value": "Room G41", "description": "Room G41" },
    { "value": "Room G42", "description": "Director" },
    { "value": "Stairs To Ground Floor", "description": "To Ground Floor" },
    { "value": "Room 101", "description": "Room 101" },
    { "value": "Room 102", "description": "EC Lab 1" },
    { "value": "Room 103", "description": "EC Lab 2" },
    { "value": "Room 105", "description": "Seminar Hall" },
    { "value": "Room 106", "description": "EDC Lab" },
    { "value": "Room 107", "description": "Store Room" },
    { "value": "Room 108", "description": "EC / TV Lab" },
    { "value": "Room 109", "description": "Room 109" },
    { "value": "Room 110", "description": "HOD EC" },
    { "value": "Room 111", "description": "Room 111" },
    { "value": "Room 112", "description": "Room 112" },
    { "value": "Room 113", "description": "Room 113" },
    { "value": "Room 114", "description": "Project Lab" },
    { "value": "Room 115", "description": "Room 115" },
    { "value": "Room 116", "description": "Room 116" },
    { "value": "Room 117", "description": "IM / DCS / OP COM Lab" },
    { "value": "Room 118", "description": "Room 118" },
    { "value": "Room 119", "description": "Room 119" },
    { "value": "Room 120", "description": "Room 120" },
    { "value": "Room 121", "description": "Room 121" },
    { "value": "Room 122", "description": "Room 122" },
    { "value": "Room 123", "description": "Room 123" },
    { "value": "Room 124", "description": "Room 124" },
    { "value": "Room 125", "description": "CP Lab 5" },
    { "value": "Room 126", "description": "CP Lab 4" },
    { "value": "Room 127", "description": "Room 127" },
    { "value": "HOD CS", "description": "HOD CS" },
    { "value": "Room 128", "description": "CP Lab 1" },
    { "value": "Room 129", "description": "CP Lab 2" },
    { "value": "Room 130", "description": "CP Lab 3" },
    { "value": "Room 131", "description": "Staff Room" },
    { "value": "Room 132", "description": "MCA Principal" },
    { "value": "Room 133", "description": "MCA Lab" },
    { "value": "Room 134", "description": "Room 134" },
    { "value": "Room 135", "description": "Room 135" },
    { "value": "Room 136", "description": "Room 136" }
]

export default Locations;